var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbleGroup1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 120,
    viewBox: "0 0 107 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2325_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 120C16.413 120 31.6742 113.679 42.9264 102.426C54.1786 91.1742 60.5 75.913 60.5 60C60.5 44.087 54.1786 28.8258 42.9264 17.5736C31.6742 6.32142 16.413 3.09838e-06 0.500014 0L0.500003 60L0.5 120Z",
    fill: "#203864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 0C90.6061 0 106.5 16.1177 106.5 36C106.5 55.8823 90.6061 72 71 72C51.3939 72 35.5 55.8823 35.5 36C35.5 16.1177 51.3939 0 71 0Z",
    fill: "#F9DF1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4075 16.1074C37.6747 21.8065 35.5 28.6458 35.5 36.0002C35.5 51.8541 45.6057 65.3143 59.641 70.118C60.2091 66.7975 60.5 63.4139 60.5 60.0002C60.5 44.0873 54.1786 28.826 42.9264 17.5739C42.4279 17.0753 41.9215 16.5865 41.4075 16.1074Z",
    fill: "#657DF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2325_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleGroup1);
export default __webpack_public_path__ + "static/media/BubbleGroup1.616e8b99b43ce896f9c79891b62eef21.svg";
export { ForwardRef as ReactComponent };